import React from 'react';
import { DialogActions, Button } from '@mui/material';

interface DialogActionButtonsProps {
    isEditing: boolean;
    onCancel: () => void;
    onDelete: () => void;
    onSave: () => void;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
    isEditing,
    onCancel,
    onDelete,
    onSave
}) => {
    return (
        <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            {isEditing && (
                <Button
                    onClick={onDelete}
                    color="error"
                >
                    Delete
                </Button>
            )}
            <Button onClick={onSave} variant="contained">
                {isEditing ? 'Update' : 'Add'}
            </Button>
        </DialogActions>
    );
};
